import React from 'react'
import { Button } from '@mui/material'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { groupsByIdAtom, productTocAtom } from '../../../api/masters.atoms'
import { GroupType } from '../../resources/products/types'
import { Table } from 'shared/ui/Table/Table'

interface GroupSelectionProps {
  onSelect(group: GroupType): void
  onCancel?(): void
  selectedGroupId?: number
}

export function GroupSelection({
  onCancel,
  onSelect,
  selectedGroupId,
}: GroupSelectionProps) {
  const { groupKeys, grouped } = useAtomValue(productTocAtom)
  const groups = useAtomValue(groupsByIdAtom)

  const columns = [
    {
      title: '',
      width: 100,
      rowContent(id: number) {
        const groupCount = grouped[id]?.length ?? 0
        const { name } = groups[id] ?? { name: 'NotGrouped' }
        const display = `${name} (${groupCount})`
        if (id === selectedGroupId) {
          return <strong>{display}</strong>
        }
        return display
      },
    },
  ]

  const selectedIndex = (index: number) => {
    const groupKey = groupKeys[index]
    const groupCount = grouped[groupKey]?.length ?? 0
    if (!groupCount) return
    const group =
      groupKey < 0
        ? ({ id: groupKey, name: 'NotGrouped' } as GroupType)
        : groups[groupKey]
    onSelect(group)
  }

  const toolBarItems = onCancel
    ? [
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
      ]
    : []

  return (
    <Table
      title="Select Group"
      items={groupKeys}
      columns={columns}
      onRowClick={selectedIndex}
      toolBarItems={toolBarItems}
    />
  )
}
